import React from "react";
import { Taller } from "./Taller";

export const TalleresList = ({ items }) => {
  return (
    <>
      {
        // Agregamos el "?" para que si items es null no rompa la app
        items?.map((item) => (
          <div key={item.id} className="col-12 col-md-4 mb-4">
            <Taller
              id={item.id}
              imagenes={item.imagenes}
              titulo={item.titulo}
              precio={item.precio}
            />
          </div>
        ))
      }
    </>
  );
};
